<template>
  <header class="header" :class="{ _hidden: headerHidden, _singlePageMode: singlePageStickyMode, _onSinglePage: isOnSinglePage }">
    <section class="headerBackground" :class="{ _scrolled: whiteStyle }"></section>
    <section class="headerContainer" :class="{ _scrolled: whiteStyle }">
      <router-link :to="{ name: 'HomePage' }">
        <SvgComponent class="header-logo" name="logo" />
      </router-link>
      <nav class="headerMenu">
        <router-link class="tabletNone headerMenu-link" :to="{ name: 'ListingsPage' }">
          Listings
        </router-link>
        <div class="headerMenu-link tabletNone" @click="scrollMeTo('#about')">
          About
        </div>
        <div class="headerMenu-link tabletNone" @click="scrollMeTo('#contact')">
          Contact
        </div>
        <!-- <a 
          id="tomap" 
          class="headerMenu-iconLink bounceY headerMenu-link"
          :href="$route.name == 'SinglePage' ? `${$frontname}map/?id=${$route.params.id}` : `${$frontname}map/`"
        > -->
        <router-link
          id="tomap"
          class="headerMenu-iconLink bounceY headerMenu-link"
          :to="{ name: 'MapPage', query: { id: $route.name == 'SinglePage' ? $route.params.id : null, location: 1 } }"
        >
          <SvgComponent name="location" />
          <span class="tabletNone">Map view</span>
        </router-link>
        <div class="burger" tabindex="0">
          <SvgComponent name="burger" />
        </div>
      </nav>
    </section>
    <section class="tempKludgeJalousie"></section>
    <Jalousie />
  </header>
</template>

<script>
  export default {
    data() {
      return {
        whiteStyle: false,
        headerHidden: false,
        lastScrollY: 0,
        scrollAnchor: 0,
        singlePageStickyMode: false,
        scrollThreshold: 50,
      };
    },
    components: {
      SvgComponent: () => import('@/components/SvgComponent'),
      Jalousie: () => import('@/components/Jalousie'),
    },
    methods: {
      scrollTimer(callback) {
        setTimeout(callback, 150);
      },

      scrollMeTo(refName) {
        var element = document.querySelector(refName);

        function scroll() {
          var element = document.querySelector(refName);
          var top = element.offsetTop;
          window.scrollTo(0, top);
        }

        if (element) {
          scroll();
        } else {
          this.$router.push(
            { name: 'HomePage' },
            this.scrollTimer(scroll),
            this.scrollTimer(scroll),
          );
        }
      },
      checkingForStickyHeader: function () {
        // console.log('checkingForStickyHeader');
        const bg =
          document.querySelector('.homeIntro-background') ||
          document.querySelector('.singleIntro-bg');
        if (
          (this.$route.name != 'HomePage' && this.$route.name != 'SinglePage') ||
          window.scrollY > window.innerHeight - 150
        ) {
          this.whiteStyle = true;
          if (bg) {
            bg.style.opacity = '0';
            bg.style.visibility = 'hidden';
          }
        } else {
          this.whiteStyle = false;
          if (bg) {
            bg.style.opacity = '1';
            bg.style.visibility = 'visible';
          }
        }

        // Handle scroll-direction-based show/hide on SinglePage
        this.handleSinglePageHeader();
      },

      handleSinglePageHeader: function () {
        const currentScrollY = window.scrollY;
        const isOnSinglePage = this.$route.name === 'SinglePage';
        const singleNavbar = document.querySelector('.singleNavbar');

        if (!isOnSinglePage || !singleNavbar) {
          this.headerHidden = false;
          this.singlePageStickyMode = false;
          this.lastScrollY = currentScrollY;
          this.scrollAnchor = currentScrollY;
          return;
        }

        // Check if we've scrolled past the intro section (viewport height)
        // This is when the SingleNavbar becomes sticky
        const introHeight = window.innerHeight;
        const navbarIsSticky = currentScrollY >= introHeight - 150;

        if (!navbarIsSticky) {
          // SingleNavbar not yet sticky - normal behavior
          this.headerHidden = false;
          this.singlePageStickyMode = false;
          this.scrollAnchor = currentScrollY;
          document.body.classList.remove('header-visible-sticky');
        } else {
          // SingleNavbar is sticky - enable scroll direction behavior
          const wasNotStickyBefore = !this.singlePageStickyMode;
          this.singlePageStickyMode = true;

          // When first entering sticky mode, hide header (user scrolled down to get here)
          if (wasNotStickyBefore) {
            this.headerHidden = true;
            this.scrollAnchor = currentScrollY;
          }

          const scrollDelta = currentScrollY - this.scrollAnchor;

          // Scrolled down past threshold - hide header
          if (scrollDelta > this.scrollThreshold) {
            this.headerHidden = true;
            this.scrollAnchor = currentScrollY;
          }
          // Scrolled up past threshold - show header
          else if (scrollDelta < -this.scrollThreshold) {
            this.headerHidden = false;
            this.scrollAnchor = currentScrollY;
          }

          // Always sync body class with header visibility state
          if (this.headerHidden) {
            document.body.classList.remove('header-visible-sticky');
          } else {
            document.body.classList.add('header-visible-sticky');
          }
        }

        this.lastScrollY = currentScrollY;
      },
    },

    computed: {
      isOnSinglePage() {
        return this.$route.name === 'SinglePage';
      },
    },

    mounted() {
      this.$router.afterEach(() => {
        this.headerHidden = false;
        this.singlePageStickyMode = false;
        this.lastScrollY = 0;
        this.scrollAnchor = 0;
        document.body.classList.remove('header-visible-sticky');
        this.checkingForStickyHeader();
      });

      this.checkingForStickyHeader();
      window.addEventListener('scroll', this.checkingForStickyHeader);
    },

    beforeDestroy() {
      document.body.classList.remove('header-visible-sticky');
      window.removeEventListener('scroll', this.checkingForStickyHeader);
    },
  };
</script>

<style lang="scss">
  .header {
    display: contents;
    user-select: none;

    &._singlePageMode {
      .headerBackground,
      .headerContainer {
        z-index: 10;
        transition: 0.3s transform, 0.2s background-color, 0.2s box-shadow, 0.2s color;
      }
    }

    &._hidden {
      .headerBackground,
      .headerContainer {
        transform: translateY(-100%);
      }
    }

    &._onSinglePage {
      .headerBackground._scrolled {
        background-color: #1F1E1E;
      }
      .headerContainer._scrolled {
        color: #FFFAF3;
        .headerMenu-link,
        .svg-burger {
          &:hover {
            color: $red;
          }
        }
      }
    }
    &-logo {
      @include middle {
        transform: scale(0.75);
      }
      @include tablet {
        transform-origin: center left;
        transform: scale(0.7);
        margin-bottom: -10px;
      }
    }
    &Background {
      height: 120px;
      background: transparent;
      z-index: 3;
      position: sticky;
      top: 0;
      will-change: background-color, box-shadow, transform;
      transition: 0.3s transform, 0.2s background-color, 0.2s box-shadow;
      @include tablet {
        height: auto;
      }
      &._scrolled {
        background-color: #FFFAF3;
        box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.1);
      }
    }
    &Container {
      position: sticky;
      top: 0;
      color: white;
      z-index: 3;
      display: flex;
      align-items: center;
      transition: 0.3s transform, 0.2s color;
      will-change: color, transform;
      &._scrolled {
        color: black;
        .headerMenu-link,
        .svg-burger {
          &:hover {
            color: $red;
          }
        }
      }
    }
    &Menu {
      display: flex;
      align-items: center;
      margin-left: auto;
      @include gap(62px, row);
      @include middle {
        /* @include gap(30px, row); */
      }
      @include tablet {
        @include gap(20px, row);
      }

      &-iconLink {
        display: flex;
        align-items: center;
        @include gap(10px, row);
      }
    }
  }

  .burger {
    cursor: pointer;
    @include middle {
      transform-origin: center right;
      transform: scale(0.7);
    }
  }
  .headerMenu-link {
    font-size: 18px;
    @include middle {
      /* font-size: 16px; */
    }
  }
  .headerMenu-link,
  .svg-burger {
    transition: 0.2s color;
    font-weight: 600;
    cursor: pointer;
    &:hover {
      color: #cccccc;
    }
  }
</style>
